import type {MembershipPassCard as MembershipPassCardType} from '@cohort/components-xps/components/cards/MembershipPassCard';
import MembershipPassCard from '@cohort/components-xps/components/cards/MembershipPassCard';
import {getImageUrl, Sizes} from '@cohort/shared/utils/media';
import {useUserLogin} from '@cohort/wallet/hooks/api/User';
import useSpaceContext from '@cohort/wallet/hooks/useSpaceContext';

const MembershipPassSkeleton = (): JSX.Element => (
  <div className="w-full overflow-hidden rounded-xl">
    <div className="animate-pulse">
      <div className="h-48 bg-gray-300"></div>
      <div className="h-1 bg-black"></div>
      <div className="space-y-2 p-4">
        <div className="h-4 rounded bg-gray-300"></div>
        <div className="h-6 w-1/2 rounded bg-gray-300"></div>
        <div className="flex justify-between">
          <div className="h-4 w-1/3 rounded bg-gray-300"></div>
          <div className="h-4 w-1/4 rounded bg-gray-300"></div>
        </div>
      </div>
    </div>
  </div>
);

const MembershipPassCardWithSkeleton = (): JSX.Element => {
  const {space} = useSpaceContext();
  const {data: user} = useUserLogin();

  if (!space || !user) {
    return <MembershipPassSkeleton />;
  }

  const membershipPassConfiguration = space.merchant.membershipPassConfiguration;

  const {membershipPass} = user;
  const membershipPassCard = {
    title: membershipPassConfiguration.title,
    imageUrl: membershipPassConfiguration.bannerFileKey
      ? getImageUrl(import.meta.env.COHORT_ENV, membershipPassConfiguration.bannerFileKey, {
          h: Sizes.M,
          w: Sizes.M,
        })
      : null,
    backgroundColorCode: membershipPassConfiguration.backgroundColorCode,
    experienceSpaceBackgroundColorCode: membershipPassConfiguration.backgroundColorCode,
    memberHandle: membershipPass.memberHandle,
    subscriptionDate: membershipPass.subscriptionDate,
    memberId: membershipPass.memberId,
    blockExplorerUrl: membershipPass.blockExplorerUrl,
  } satisfies MembershipPassCardType;

  return <MembershipPassCard membershipPassCard={membershipPassCard} />;
};

export default MembershipPassCardWithSkeleton;
